export enum LOAD_SELECT_COMPLAINTS {
	START = 'LOAD_SELECT_COMPLAINTS_START',
	DONE = 'LOAD_SELECT_COMPLAINTS_DONE',
	FAILED = 'LOAD_SELECT_COMPLAINTS_FAILED'
}

export enum LOAD_COMPLAINT {
	START = 'LOAD_COMPLAINT_START',
	DONE = 'LOAD_COMPLAINT_DONE',
	FAILED = 'LOAD_COMPLAINT_FAILED'
}

export enum CREATE_COMPLAINT {
	START = 'CREATE_COMPLAINT_START',
	DONE = 'CREATE_COMPLAINT_DONE',
	FAILED = 'CREATE_COMPLAINT_FAILED'
}
